import React from 'react';
import orgConfig from 'org/configs/org.config';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { Cards, DaysToExpire } from 'core/modules/Instore2/partials';
import { useScrollToFaq } from 'core/modules/Instore2/hooks/useScrollToFaq';
import { EasylinkModalTitle } from '../partials';

import '../InstoreOfferDetails.scss';

const { instoreLabel } = orgConfig;

function EasyLinkView({ offer, wasAlreadyLinked }) {
  const { displayRate, currency, rclonMerchantName } = offer;
  const { onFaqClick } = useScrollToFaq();

  return (
    <div className="mn_instoreOfferDetails mn_easyLinkView">
      <div className="mn_successIcon" />
      <EasylinkModalTitle offer={offer} wasAlreadyLinked={wasAlreadyLinked} />
      <div className="mn_offerAndCardsInfo">
        <div id="mn_dialogDescription" className="mn_offerInfo">
          Earn {displayRate} {currency} {instoreLabel} at {rclonMerchantName}<span className="mn_dot">.</span>
        </div>
        <div className="mn_cardsAndDays">
          <Cards offer={offer} />
          <DaysToExpire offer={offer} />
        </div>
      </div>
      <div className="mn_easyLinkFaq">
        <p>
          If you made a purchase online, we'll continue to track your purchase as usual.
          We'll link in-store offers for you when you click to shop online at store sites with active in-store offers.
        </p>
        <p>
          You can manually remove the link if you'd rather not have this offer linked to your participating card(s).
          Read the <button className="mn_basicButton" onClick={onFaqClick}>FAQs</button> for more information.
        </p>
      </div>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><EasyLinkView {...props} /></ComponentErrorBoundary>;
